import { apiClient } from '~/api/client';

type ShowParams = {
  id: number;
  period: Period;
};

type TeamMember = {
  avatar_url: string;
  id: string;
  name: string;
};

export type Team = {
  name: string;
  realtors: TeamMember[];
  size: number;
  team_lead: TeamMember;
};

type Response = {
  data: Team;
  error?: string;
};

export const show = async ({ id, period }: ShowParams) =>
  apiClient.get<Response>(`/teams/${id}`, { params: { period: period } });
